class MemberList {
  constructor() {
    this.UserOid = [];
    this.UserName = [];
    this.FirstName = [];
    this.LastName = [];
    this.UserEmail = [];
    this.CreatedDate = [];
    this.UserType = [];
    //this.Roles= [][];
    this.Status = [];
    this.MemberListResp = null;
    this.SearchMemberListResp = null;
    this.selectedUser = null;
    this.firstUser = null;
    this.totalRecords = 0;
  }

  getUserOid(index) {
    return this.UserOid[index];
  }

  setUserOid(index, Oid) {
    this.UserOid[index] = Oid;
  }

  getUserName(index) {
    return this.UserName[index];
  }

  setUserName(index, Username) {
    this.UserName[index] = Username;
  }

  getFirstName(index) {
    return this.FirstName[index];
  }

  setFirstName(index, FirstName) {
    this.FirstName[index] = FirstName;
  }

  getLastName(index) {
    return this.LastName[index];
  }

  setLastName(index, LastName) {
    this.LastName[index] = LastName;
  }

  getUserEmail(index) {
    return this.UserEmail[index];
  }

  setUserEmail(index, UserEmail) {
    this.UserEmail[index] = UserEmail;
  }

  getCreatedDate(index) {
    return this.CreatedDate[index];
  }

  setCreatedDate(index, CreatedDate) {
    this.CreatedDate[index] = CreatedDate;
  }

  getUserType(index) {
    return this.UserType[index];
  }

  setUserType(index, UserType) {
    this.UserType[index] = UserType;
  }

  getStatus(index) {
    return this.Status[index];
  }

  setStatus(index, Status) {
    this.Status[index] = Status;
  }

  getMemberListResp() {
    return this.MemberListResp;
  }

  setMemberListResp(MemberListResp) {
    this.MemberListResp = MemberListResp;
  }

  getSearchMemberListResp() {
    return this.SearchMemberListResp;
  }

  setSearchMemberListResp(SearchMemberListResp) {
    this.SearchMemberListResp = SearchMemberListResp;
  }

  getSelectedUser() {
    return this.selectedUser;
  }

  setSelectedUser(selectedUser) {
    this.selectedUser = selectedUser;
  }

  getFirstUser() {
    return this.firstUser;
  }

  setFirstUser(firstUser) {
    this.firstUser = firstUser;
  }

  getTotalRecords() {
    return this.totalRecords;
  }

  setTotalRecords(totalRecords) {
    this.totalRecords = totalRecords;
  }

  resetMemberList() {
    this.UserOid = [];
    this.UserName = [];
    this.FirstName = [];
    this.LastName = [];
    this.UserEmail = [];
    this.CreatedDate = [];
    this.UserType = [];
    //this.Roles= [][];
    this.Status = [];
    this.MemberListResp = null;
    this.SearchMemberListResp = null;
    this.selectedUser = null;
    this.firstUser = null;
    this.totalRecords = 0;
  }
}
export default new MemberList();
